<template lang="pug">
img(
  :src="url"
  :class="`avatar avatar-${size}`"
  :height="dimension"
  :width="dimension"
  :style="style"
  )
</template>

<script>
import { avatarUrlForStyle } from '~/utils/avatar';

export default {
  name: 'AppAvatar',
  props: {
    avatar: {
      required: true,
    },
    size: {
      type: String,
      default: 'speck',
    },
  },
  computed: {
    url() {
      return avatarUrlForStyle(this.avatar, this.size);
    },
    dimension() {
      switch (this.size) {
        case 'speck':
          return 25;
        case 'medium':
          return 32;
        case 'thumb':
          return 50;
        case 'normal':
          return 150;
      }

      return parseInt(this.size);
    },
    style() {
      return this.size > 0 ? { width: this.size, height: this.size } : {};
    },
  },
};
</script>
